<template>
    <div style="width: 100%">
        <h5  v-if="!oracle.isEmpty(lawyer.lawyer_company)" class="font-weight-bold">{{language.lang('Company name')}}</h5>
        <span v-if="!oracle.isEmpty(lawyer.lawyer_company)" >{{lawyer.lawyer_company}}</span>
        <h5 v-if="!oracle.isEmpty(lawyer.lawyer_location_canada) || !oracle.isEmpty(lawyer.lawyer_location_iran)"  class="font-weight-bold mt-3">{{language.lang('Office location')}}</h5>
        <h6 v-if="!oracle.isEmpty(lawyer.lawyer_location_canada)" class="">{{language.lang('Canada: ')}}<span style="font-size: 0.875rem">{{lawyer.lawyer_location_canada}}</span></h6>
        <h6 v-if="!oracle.isEmpty(lawyer.lawyer_location_iran)" class="">{{language.lang('Iran: ')}}<span style="font-size: 0.875rem">{{lawyer.lawyer_location_iran}}</span></h6>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        props: {
            lawyer: Object
        },
        data: () => ({
            oracle: oracle,
            language: language,
            isEN: oracle.isEN(),
        }),
        mounted() {

        }
    };
</script>
<style>
</style>
